class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    const closeButton = this.querySelector('button[type="button"]');

    // تحقق من وجود العناصر قبل التعامل معها
    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  isOpen() {
    return this.detailsContainer?.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (details?.hasAttribute('open')) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details')?.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusTarget = this.detailsContainer?.querySelector('[tabindex="-1"]');
    const inputFocus = this.detailsContainer?.querySelector('input:not([type="hidden"])');

    trapFocus(focusTarget, inputFocus);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer?.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('details-modal')) {
  customElements.define('details-modal', DetailsModal);
}
